export default __webpack_public_path__ + "static/media/wDress_1_c1.1aa32d1d.jpeg";